import { FeatureConfiguration } from "..";
import { QuickSellReducer } from "./reducers";

export * from "./types";
export * from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.quickSell = QuickSellReducer;
}
